// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  TOGGLE_MENU: '[data-fragment="WebLayout.toggleMenu"]',
};

export default class WebLayout extends WebComponent {
  constructor(props) {
    super(props);
    this.scrollFn = this.scrollFn.bind(this);
  }
  didMount() {
    this.header = this.element.querySelector('.header');
    window.addEventListener('scroll', this.scrollFn);
    this.on('click', fragments.TOGGLE_MENU, this.handleToggleMenu);

    // helper function
    function insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    // Heureka badge specific
    setTimeout(function(){
      this.hBadge = document.getElementById('showHeurekaBadgeHere-11');
      this.hBadgeParent = document.querySelector('.footer__links-list--contacts');

        if(this.hBadge && this.hBadgeParent) {
          this.hBadge.classList.add('active');
          insertAfter(this.hBadge, this.hBadgeParent);
        }
      }, 1000);

  }

  handleToggleMenu = () => {
    // pridej overflow full
    if (!this.header.classList.contains('active')) {
      document.body.classList.add('overflow-full');
    } else {
      document.body.classList.remove('overflow-full');
    }
  };

  willUnmount() {
    window.removeEventListener('scroll', this.scrollFn);
  }

  scrollFn() {
    if (this.header) {
      let offsetAmount = 650; // nastaveno fixne kvuli potlaceni poskakovani v detailu produktu (vyber variant) pri implementaci TurboLinks

      if (window.pageYOffset > offsetAmount) {
        this.header.classList.add('header--sticky');
      }
      if (window.pageYOffset <= offsetAmount) {
        this.header.classList.remove('header--sticky');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebLayout.js